<template lang="pug">
  div
    div(v-if="comment.payload.replied_comment_id === 0"
      class="reply-wrapper"
      :class="{'reply-wrapper--me': isMe}")
      comment-render(text="Message has been deleted")

    div(v-if="comment.payload.replied_comment_id !== 0"
      class="reply-wrapper"
      :class="{'reply-wrapper--me': isMe }"
      @click="clickHandler")
      div(class="reply-sender") {{ comment.payload.replied_comment_sender_username }}
      div(class="reply-caption-container" v-if="isAttachment")
        comment-render(v-if="isAttachment && attachmentHasCaption"
          :text="comment.payload.replied_comment_payload.caption")
        image-loader(v-if="isAttachment"
          :comment="comment"
          :message="comment.payload.replied_comment_message"
          :thumbnailMode="true"
          :on-click-image="onClickImage"
          :callback="callback")
      comment-render(v-if="!isAttachment"
        :text="repliedText")

    image-loader(v-if="comment.isAttachment(comment.payload.text)"
      :comment="comment"
      :message="comment.payload.text"
      :thumbnailMode="true"
      :on-click-image="onClickImage"
      :callback="callback")

    comment-render(v-if="!comment.isAttachment(comment.payload.text)"
      :text="comment.payload.text")
</template>

<script>
import ImageLoader from './ImageLoader';
import CommentRender from './CommentRender';

export default {
  name: 'CommentReply',
  components: { ImageLoader, CommentRender },
  props: ['comment', 'isMe', 'clickHandler', 'onClickImage', 'callback'],
  computed: {
    isAttachment() {
      return this.comment.isAttachment(this.comment.payload.replied_comment_message);
    },
    attachmentHasCaption() {
      return this.comment.payload.replied_comment_payload.caption != null
        && !this.comment.payload.replied_comment_payload.caption.includes('This message was sent on previous session by');
    },
    repliedText() {
      const isTrue = this.comment.payload.replied_comment_message.includes('This message was sent on previous session by');
      let text = '';
      if (isTrue) {
        const lines = this.comment.payload.replied_comment_message.split('\n').filter(l => l.trim() !== '');
        lines.forEach((line, index) => {
          if (index < lines.length - 2) {
            text += `${line.trim()}\n`;
          }
        });
      } else {
        text = this.comment.payload.replied_comment_message;
      }
      return text;
    },
  },
};
</script>

<style lang="stylus" scoped>
.reply-wrapper .reply-caption-container
  align-items center

</style>



// WEBPACK FOOTER //
// src/components/CommentReply.vue